<template>
    <v-dialog v-model="dialog" fullscreen persistent transition="dialog-bottom-transition">
        <div class="timer-container">
            <v-progress-circular :size="250" :width="10" :rotate="isTimeCircuit ? 0 : -90" :value="progressValue"
                :indeterminate="isTimeCircuit" color="primary" />
            <div class="timer-text">{{ formattedTime }}</div>
            <div v-if="isTabata" class="timer-subtext">{{ isWorking ? $t('common.working') : $t('common.resting') }}</div>
            <v-btn v-if="isTimeCircuit || closable" class="timer-btn normal-btn black--text" @click="hide" color="primary"
                depressed>
                {{ $t('common.finish_timer') }}
            </v-btn>
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: {
        duration: {
            type: Number,
            default: 60,
        },
        type: {
            type: String,
            default: null,
        },
        tabata: {
            type: Object,
            default: null
        },
        closable: {
            type: Boolean,
            default: false,
        },
        infinite: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            timeElapsed: 0,
            currentSeries: 0,
            isWorking: true,
            sumSecondsInterval: null,
            timeInCurrentPhase: 0,
        };
    },
    computed: {
        progressValue() {
            if (this.isTimeCircuit) return 100;
            if (this.isTabata) {
                const totalPhaseTime = this.isWorking ? this.tabata.timeWork : this.tabata.timeRest;
                return (this.timeInCurrentPhase / totalPhaseTime) * 100;
            }
            return (this.timeElapsed / this.duration) * 100;
        },
        formattedTime() {
            const minutes = Math.floor(this.timeElapsed / 60);
            const seconds = Math.floor(this.timeElapsed % 60);
            return `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        },
        isTimeCircuit() {
            return this.type === 'time';
        },
        isTabata() {
            return this.type === 'tabata';
        }
    },
    methods: {
        show() {
            this.dialog = true;
            this.startTimer();
        },
        hide() {
            this.dialog = false;
            this.$emit("hide");
            clearInterval(this.sumSecondsInterval);
        },
        startTimer() {
            this.timeElapsed = 0;
            this.currentSeries = 0;
            this.isWorking = true;
            this.timeInCurrentPhase = 0;

            this.sumSecondsInterval = setInterval(() => {
                if (this.isTabata) {
                    this.handleTabataTimer();
                } else if (this.isTimeCircuit || this.infinite) {
                    this.timeElapsed++;
                } else {
                    if (this.timeElapsed < this.duration) {
                        this.timeElapsed++;
                        if (this.type === 'enom' && this.timeElapsed % 60 === 0) {
                            this.playBeep();
                        }
                    } else {
                        if (this.type === 'amrap') this.playBeep();
                        clearInterval(this.sumSecondsInterval);
                        this.hide();
                    }
                }
            }, 1000);
        },
        handleTabataTimer() {
            this.timeInCurrentPhase++;
            this.timeElapsed++;
            const totalPhaseTime = this.isWorking ? this.tabata.timeWork : this.tabata.timeRest;
            if (this.timeInCurrentPhase >= totalPhaseTime) this.switchPhase()
            if (!this.isWorking && this.currentSeries >= this.tabata.sets) {
                this.playBeep();
                this.hide();
            }
        },
        switchPhase() {
            this.playBeep();
            this.isWorking = !this.isWorking;
            this.timeInCurrentPhase = 0;
            this.timeElapsed = 0;
            if (!this.isWorking) this.currentSeries++
        },
        playBeep() {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.type = "sine";
            oscillator.frequency.setValueAtTime(1000, audioContext.currentTime);

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            gainNode.gain.setValueAtTime(1, audioContext.currentTime);
            oscillator.start();

            setTimeout(() => {
                oscillator.stop();
            }, 200);
        }
    },
    beforeDestroy() {
        clearInterval(this.sumSecondsInterval);
    },
};
</script>

<style scoped>
.timer-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
    height: 100%;
}

.timer-text {
    position: absolute;
    font-size: 56px;
    font-weight: bold;
}

.timer-subtext {
    position: absolute;
    top: 350px;
    bottom: 0;
    margin: auto;
    height: auto;
}

.timer-btn {
    position: absolute;
    top: 350px;
    bottom: 0;
    margin: auto;
    height: auto;
}
</style>
